import { useState } from "react";
import Avatars from "../../../utils/avatar/Avatars";
import CameraImg from "../../../assets/images/camera.png";
import ReactIcons from "../../../utils/icons";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  blockSelector,
  clearBlockList,
  clearDistrictList,
  clearSchoolList,
  districtSelector,
  genderSelector,
  getBlock,
  getDistrict,
  getGender,
  getSchool,
  getSchoolByUDISE,
  getState,
  schoolSelector,
  stateSelector,
  updateProfile,
} from "../../../redux/slices/profile/profileSlice";
import { useEffect } from "react";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getTranslatedTextSelector } from "../../../redux/slices/translatedText/getTranslatedText";
import { indianMobileNumber, crrNumberRegex } from "../../../utils/Regex/regex";
import axios from "axios";
import Modal from "../../modal/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faXmark,
  faSignOutAlt,
} from "@fortawesome/free-solid-svg-icons";

import $ from "jquery";
import { decrypt, encrypt } from "../../encryption/Encryption";
import {
  GetProfession,
  GetQualification,
  GetSpecialization,
  CheckProfileCompletion,
  GetReasons,
} from "./utils";
import ServerUpgradtionModal from "../../ServerUpgradtionModal";
import { ModuleListShimmer } from "../../../utils/certificateShimmer/CourseListShimmer";
import Loader from "../../../utils/loader/Loader";
import { baseURL } from "../../../utils/http/http-common";
import whatsappIcon from "../../../assets/images/whatsapp.png";
import reload from "../../../assets/images/reload.svg";
import LogoutModalPopup from "../../../utils/Header/LogoutModalPopup";

const Profile = (props) => {
  const [profilePic, setProfilePic] = useState({});
  const [base64String, setBase64String] = useState("");
  const [isProfileReupload, setIsProfileReupload] = useState("true");
  const [showMessage, setShowMessage] = useState(false);
  const [showSchoolName, setShowSchoolName] = useState(false);
  const [userDataById, setUserDataById] = useState(null);
  const userDetails = JSON.parse(localStorage.getItem("user"));
  //const userDetails = userDataById;

  const userId = JSON.parse(localStorage.getItem("id"));
  const [UdiseCode, setUdiseCode] = useState("");
  const [schoolByUdise, setSchoolByUdise] = useState();
  const [districtByUdise, setDistrictByUdise] = useState();
  const [stateByUdise, setStateByUdise] = useState();
  const [blockByUdise, setBlockByUdise] = useState();
  const [locationStateBeforeUdise, setLocationStateBeforeUdise] =
    useState(null);
  const [showButtonText, setShowButtonText] = useState(false);
  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const stateIdFromUrl = new URLSearchParams(location.search).get("stateId");
  const hasStateIdInUrl = Boolean(stateIdFromUrl);
  const language_id = localStorage.getItem("l_id");
  const [serverError, setServerError] = useState(false);
  const teacherId = userDetails?.teacherId;

  const checkDateFormat = (date) => {
    const regex = /^\d{4}-\d{2}-\d{2}$/;

    // Test if the date string matches the pattern
    const isMatch = regex.test(date);

    return isMatch;
  };

  const formatDate = (date) => {
    const parts = date?.split("-");

    const dateObj = new Date(`${parts[1]} ${parts[0]}, ${parts[2]}`);

    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const day = String(dateObj.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  };

  const [state, setState] = useState({
    stateId: "",
    districtId: "",
    schoolId: "",
    schoolName: "",
    blockId: "",
    genderId: "",
    firstName: userDetails?.firstName,
    lastName: userDetails?.lastName,
    mobileNo: userDetails?.mobileNo ? decrypt(userDetails?.mobileNo) : "",
    whatsAppNo: userDetails?.whatsAppNo ? decrypt(userDetails?.whatsAppNo) : "",
    emailId: userDetails?.emailId ? decrypt(userDetails?.emailId) : "",
    dob: userDetails?.dob
      ? checkDateFormat(decrypt(userDetails?.dob))
        ? decrypt(userDetails?.dob)
        : formatDate(decrypt(userDetails.dob))
      : "",
    profileImage: "",
    userImage: "",
    professionId: [],
    qualificationId: [],
    specializationId: [],
    crrNo: userDetails?.crrNum ? userDetails?.crrNum : "",
    reasonId: [],
    institutionName: userDetails?.institutionName ?? "",
  });

  const [professionOptions, setProfessionOptions] = useState([]);
  const [qualificationOptions, setQualificationOptions] = useState([]);
  const [specializationOptions, setSpecializationOptions] = useState([]);
  const [reasonOptions, setReasonOptions] = useState([]);

  const { firstName, emailId, dob } = state;

  const dispatch = useDispatch();

  const gendersSelector = useSelector(genderSelector);
  const statesSelector = useSelector(stateSelector);
  const districtsSelector = useSelector(districtSelector);
  const schoolsSelector = useSelector(schoolSelector);
  const blocksSelector = useSelector(blockSelector);
  const getTranslateText = useSelector(getTranslatedTextSelector);

  const getValuesForStatesAndGender = () => {
    dispatch(getGender());
    dispatch(getState());
  };

  const isProfileCompleted = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const requiredFields = [
      "dob",
      "gender",
      // "lastName",
      "stateId",
      "userName",
      "firstName",
      "mobileNo",
      "districtId",
      "blockId",
    ];

    if (!user) {
      return false;
    }

    if (user.userTypeId === 3 || user.userTypeId === 8) {
      requiredFields.push("schoolId");
    }
    /* It's not mendatory from api side, This validation apply from frontend side*/
    // if (user.userTypeId === 8) {
    //   requiredFields.push("professionId");
    // }
    return requiredFields.every((field) => user[field]);
  };

  const handleProfilPic = async (e) => {
    const imageFile = e.target.files[0];
    // var reader = new FileReader();
    // reader.readAsDataURL(imageFile);
    // reader.onload = function () {
    //   setBase64String(reader.result);
    //   setIsProfileReupload(reader.result);
    // };
    // reader.onerror = function (error) {
    //   console.log("Error: ", error);
    // };

    const formData = new FormData();
    formData.append("userId", userId);
    formData.append("userImage", imageFile);

    try {
      const response = await axios.post(
        `${baseURL}/Login/UpdateUserProfileImage`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (response?.data?.message === "Success") {
        const userData = JSON.parse(localStorage.getItem("user")) || {};
        if (userData) {
          userData.profilePicURL = response?.data?.response[0]?.imageUrl;

          localStorage.setItem("user", JSON.stringify(userData));
        }

        toast.success(
          getTranslateText?.data?.length > 0
            ? getTranslateText?.data?.filter(
                (item) => item?.pageKey === "key_prof_img_update_success",
              )[0]?.keyValue
            : "Profile image is update successfully",
        );
      } else {
        toast.error("Profile image upload failed!!!");
      }
    } catch (error) {
      console.error("Error uploading image:", error);
    }

    setProfilePic((prev) => ({ ...prev, selectedFile: imageFile }));
  };

  const handleChange = (e) => {
    setState((prev) => ({ ...prev, [e.target.name]: e.target.value }));

    if (e.target.name === "school") {
      if (e.target.value === "other") {
        setShowSchoolName(true);
      } else if (e.target.value) {
        setState((prev) => ({ ...prev, [e.target.name]: e.target.value }));
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    if (!state?.firstName?.trim()) {
      setShowMessage(true);
      setLoading(false);
      toast.warn("Please enter first name");
      return;
    }
    if (
      state.emailId &&
      !/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/.test(state.emailId)
    ) {
      setShowMessage(true);
      setLoading(false);
      toast.warn("Email should be in the correct format.");
      return;
    }
    if (
      (userDetails.userTypeId === 7 ||
        userDetails.userTypeId === 8 ||
        userDetails.userTypeId === 12) &&
      state.crrNo &&
      !crrNumberRegex.test(state.crrNo)
    ) {
      setShowMessage(true);
      setLoading(false);
      toast.warn("Invalid crr number.");
      return;
    }
    if (userDetails?.userTypeId === 12 && state.crrNo === "") {
      setShowMessage(true);
      toast.error("Please enter CRR number");
      setLoading(false);
      return;
    }
    if (
      userDetails.userTypeId === 7 &&
      !schoolByUdise &&
      (!state?.schoolId?.[0]?.value || state?.schoolId?.[0]?.value === 0) &&
      (!state?.reasonId?.[0]?.value || state?.reasonId?.[0]?.value === 0)
    ) {
      setShowMessage(true);
      setLoading(false);
      toast.warn("Please select a school or provide a reason");
      return;
    }
    if (
      (userDetails?.userTypeId === 8 || userDetails?.userTypeId === 12) &&
      (state.professionId[0]?.value === undefined ||
        state.professionId[0]?.value === null ||
        state.professionId[0]?.value === 0)
    ) {
      setShowMessage(true);
      toast.error("Please select profession..!");
      setLoading(false);
      return;
    }
    if (
      (userDetails?.userTypeId === 8 || userDetails?.userTypeId === 12) &&
      (state.qualificationId[0]?.value === undefined ||
        state.qualificationId[0]?.value === null ||
        state.qualificationId[0]?.value === 0)
    ) {
      setShowMessage(true);
      toast.error("Please select qualification..!");
      setLoading(false);
      return;
    }
    if (
      userDetails?.userTypeId === 8 &&
      (state.specializationId[0]?.value === undefined ||
        state.specializationId[0]?.value === null ||
        state.specializationId[0]?.value === 0)
    ) {
      setShowMessage(true);
      toast.error("Please select specialization..!");
      setLoading(false);
      return;
    }

    // let formData = new FormData();
    // formData.append("UserId", userId);
    // formData.append(
    //   "StateId",
    //   !stateByUdise ? state.stateId[0]?.value : stateByUdise[0].value
    // );
    // formData.append(
    //   "DistrictId",
    //   !districtByUdise ? state?.districtId[0]?.value : districtByUdise[0].value
    // );
    // formData.append(
    //   "SchoolId",
    //   !schoolByUdise
    //     ? state?.schoolId[0]?.value
    //     : // ? 1
    //     // : state?.schoolId[0]?.value
    //     schoolByUdise
    //     ? schoolByUdise[0].value
    //     : ""
    // );
    // formData.append(
    //   "BlockId",
    //   !blockByUdise ? state.blockId[0]?.value : blockByUdise[0].value
    // );
    // formData.append("Gender", state.genderId[0]?.value);
    // formData.append("FirstName", state.firstName);
    // formData.append("LastName", state.lastName ? state.lastName : "");
    // formData.append("MobileNo", encrypt(state.mobileNo));
    // formData.append("WhatsAppNo", encrypt(state.whatsAppNo));
    // formData.append("EmailId", encrypt(emailId));
    // formData.append("DOB", encrypt(dob));
    // //formData.append("ProfileImage", "");
    // //formData.append("SchoolName", state.schoolName ? state?.schoolName : "");
    // formData.append(
    //   "SchoolName",
    //   state?.schoolName
    //     ? state?.schoolName
    //     : schoolByUdise
    //     ? schoolByUdise[0].label
    //     : ""
    // );
    // formData.append("QualificationId", state.qualificationId[0]?.value || "");
    // formData.append("ProfessionId", state.professionId[0]?.value || "");
    // formData.append("SpecializationId", state.specializationId[0]?.value || "");
    // formData.append("CRRNum", state.crrNo);
    // formData.append(
    //   "ReasonId",
    //   state?.schoolId[0]?.value || schoolByUdise
    //     ? ""
    //     : state.reasonId[0]?.value || ""
    // );

    let formData = {
      UserId: userId,
      StateId: !stateByUdise ? state.stateId[0]?.value : stateByUdise[0].value,
      DistrictId: !districtByUdise
        ? state?.districtId[0]?.value
        : districtByUdise[0].value,
      SchoolId: !schoolByUdise
        ? state?.schoolId[0]?.value
        : // ? 1
          // : state?.schoolId[0]?.value
          schoolByUdise
          ? schoolByUdise[0].value
          : "",
      BlockId: !blockByUdise ? state.blockId[0]?.value : blockByUdise[0].value,
      // BlockId:
      //   userDetails.userTypeId === 12
      //     ? 1209
      //     : !blockByUdise
      //     ? state.blockId[0]?.value
      //     : blockByUdise[0].value,
      Gender: state.genderId[0]?.value,
      FirstName: state.firstName,
      LastName: state.lastName || "",
      MobileNo: encrypt(state.mobileNo),
      WhatsAppNo: encrypt(state.whatsAppNo),
      EmailId: encrypt(emailId),
      DOB: encrypt(dob),
      SchoolName: state?.schoolName
        ? state?.schoolName
        : schoolByUdise
          ? schoolByUdise[0].label
          : "",
      QualificationId: state.qualificationId[0]?.value || "",
      ProfessionId: state.professionId[0]?.value || "",
      SpecializationId: state.specializationId[0]?.value || "",
      CRRNum: state.crrNo,
      ReasonId:
        state?.schoolId[0]?.value || schoolByUdise
          ? ""
          : state.reasonId[0]?.value || "",
      InstitutionName: state.institutionName,
    };

    if (error) {
      setShowMessage(true);
      toast.warn("Please enter a valid mobile number");
      return;
    }

    // regex for school name contains alphabet , dot and space in middle
    if (
      state.schoolName &&
      /^(?=.*[a-zA-Z])([1-7-9.,\/ ])+$/.test(state.schoolName)
    ) {
      setShowMessage(true);
      toast.warn("school name should conntains only alphabet");
      return;
    }

    if (isProfileReupload) {
      dispatch(updateProfile(formData))
        .unwrap()
        .then((resp) => {
          const {
            blockId,
            districtId,
            firstName,
            lastName,
            profilePicURL,
            schoolId,
            schoolName,
            stateId,
            whatsAppNo,
            gender,
            mobileNo,
            dob,
            emailId,
            qualificationId,
            professionalId,
            specializationId,
            crrNum,
            reasonId,
            institutionName,
          } = resp?.response[0];
          // qualificationId , professionId , specializationId , crrNum

          const getUser = JSON.parse(localStorage.getItem("user"));
          localStorage.removeItem("user");
          const user = {
            ...getUser,
            blockId: blockId,
            districtId,
            firstName,
            lastName: state.lastName,
            schoolId,
            schoolName,
            stateId,
            whatsAppNo,
            profilePicURL,
            gender,
            mobileNo,
            dob,
            emailId,
            qualificationId,
            professionId: professionalId,
            specializationId,
            crrNum,
            reasonId: reasonId,
            institutionName,
          };
          localStorage.setItem("user", JSON.stringify(user));

          if (resp?.status === 1) {
            setShowMessage(true);
            toast.success(
              getTranslateText?.data?.length > 0
                ? getTranslateText?.data?.filter(
                    (item) => item?.pageKey === "key_profile_update_success",
                  )[0]?.keyValue
                : "Profile is update successfully",
            );

            $(".disableSidebar")
              .removeClass("pointer-events-none")
              .addClass("cursor-pointer");
            setTimeout(() => {
              navigate("/user/dashboard", {
                state: { isProfileCompleted: true },
              });
            }, 4000);
          } else {
            setShowMessage(true);
            toast.warning("Some Error Occured");
          }
        })
        .catch((error) => {
          setShowMessage(true);
          setServerError(true);
          console.log(error);
        });
    }
    setLoading(true);
  };

  useEffect(() => {
    getValuesForStatesAndGender();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setLoader(true);
      if (state?.stateId[0]?.value) {
        await dispatch(getDistrict(state?.stateId[0]?.value));
      }
      setLoader(false);
    };
    fetchData();
  }, [state.stateId]);

  useEffect(() => {
    const fetchData = async () => {
      setLoader(true);
      if (state?.districtId[0]?.value) {
        await dispatch(getBlock(state?.districtId[0]?.value));
      }
      setLoader(false);
    };
    fetchData();
  }, [state.districtId]);

  // useEffect(() => {
  //   if (state.stateId && state.districtId) {
  //     const stateId = state?.stateId[0]?.value;
  //     const districtId = state?.districtId[0]?.value;

  //     dispatch(getSchool({ stateId, districtId }));
  //   }
  // }, [state.districtId]);

  useEffect(() => {
    const fetchData = async () => {
      setLoader(true);
      if (state.blockId) {
        const blockID = state?.blockId[0]?.value;
        if (blockID) {
          await dispatch(getSchool({ blockID }));
        }
      }
      setLoader(false);
    };
    fetchData();
  }, [state.blockId]);

  useEffect(() => {
    if (stateByUdise) return;
    if (statesSelector?.data?.length > 0) {
      const { data } = statesSelector;
      const defaultStateId = stateIdFromUrl || userDetails?.stateId;

      const defaultStates = data.filter(
        (item) => item?.value === Number.parseInt(defaultStateId),
      );

      setState((prev) => ({ ...prev, stateId: defaultStates }));
    }
  }, [statesSelector?.data, stateIdFromUrl, stateByUdise]);

  useEffect(() => {
    if (districtByUdise) return;
    if (districtsSelector?.data?.length > 0) {
      const { data } = districtsSelector;

      const defaultDistrict = data.filter(
        (item) => item.value === Number.parseInt(userDetails?.districtId),
      );

      setState((prev) => ({ ...prev, districtId: defaultDistrict }));
    }
  }, [districtsSelector?.data, districtByUdise]);

  useEffect(() => {
    if (schoolByUdise) return;
    if (schoolsSelector?.data?.length > 0) {
      const { data } = schoolsSelector;

      const defaultSchool = data.filter((item) => {
        return item?.value === userDetails?.schoolId;
      });
      if (defaultSchool.length === 0) {
        setState((prev) => ({
          ...prev,
          schoolId: [{ value: 0, label: userDetails?.schoolName }],
        }));
      } else {
        setState((prev) => ({ ...prev, schoolId: defaultSchool }));
      }
    }
  }, [schoolsSelector?.data, schoolByUdise]);

  useEffect(() => {
    if (gendersSelector?.data?.length > 0) {
      const { data } = gendersSelector;

      const defaultGender = data.filter(
        (item) => item.value === Number.parseInt(userDetails?.gender),
      );

      setState((prev) => ({ ...prev, genderId: defaultGender }));
    }
  }, [gendersSelector?.data]);

  useEffect(() => {
    if (blockByUdise) return;
    if (blocksSelector?.data?.length > 0) {
      const { data } = blocksSelector;

      const defaultblock = data.filter(
        (item) => item.value === Number.parseInt(userDetails?.blockId),
      );

      setState((prev) => ({ ...prev, blockId: defaultblock }));
    }
  }, [blocksSelector?.data, blockByUdise]);

  const applyUdise = async () => {
    if (!showButtonText) {
      try {
        const response = await dispatch(
          getSchoolByUDISE({ UdiseCode }),
        ).unwrap();
        const { status } = response;
        if (status === 1) {
          const { response: apiResponse } = response;
          const schoolOption = {
            value: apiResponse[0].schoolId,
            label: apiResponse[0].schoolName,
          };
          const districtOption = {
            value: apiResponse[0].districtId,
            label: apiResponse[0].districtName,
          };
          const blockOption = {
            value: apiResponse[0].blockId,
            label: apiResponse[0].blockName,
          };
          const stateOption = {
            value: apiResponse[0].stateId,
            label: apiResponse[0].stateName,
          };

          setLocationStateBeforeUdise({
            stateId: state.stateId,
            districtId: state.districtId,
            blockId: state.blockId,
            schoolId: state.schoolId,
            schoolName: state.schoolName,
          });
          setSchoolByUdise([schoolOption]);
          setDistrictByUdise([districtOption]);
          setBlockByUdise([blockOption]);
          setStateByUdise([stateOption]);
          setShowSchoolName(false);
          setState((prev) => ({
            ...prev,
            stateId: [stateOption],
            districtId: [districtOption],
            blockId: [blockOption],
            schoolId: [schoolOption],
            schoolName: apiResponse[0].schoolName || "",
          }));
        }
      } catch (error) {}
    } else {
      setStateByUdise();
      setDistrictByUdise();
      setBlockByUdise();
      setSchoolByUdise();
      setUdiseCode("");
      setShowSchoolName(false);
      if (locationStateBeforeUdise) {
        setState((prev) => ({
          ...prev,
          ...locationStateBeforeUdise,
        }));
      }
      setLocationStateBeforeUdise(null);
    }
  };

  const currentDate = new Date().toISOString().split("T")[0];

  const changeRequest = async (requestId) => {
    if (!selectedFile) {
      console.error("No file selected");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("FilePath", "");
      formData.append("RequestTypeID", requestId);
      formData.append("Priority", "0");
      formData.append("UserID", userId); // Replace with dynamic userId if needed
      formData.append("UpdatedDate", ""); // Adjust accordingly
      formData.append("DocumentTypeId", "0"); // Adjust accordingly
      formData.append("Status", "1");
      formData.append("UpdatedBy", "0");
      formData.append("CreatedDate", new Date().toISOString()); // Current date
      formData.append("AppVersion", "string");
      formData.append("RequestStatusID", "1");
      formData.append("Description", "string"); // Replace with real description
      formData.append("CreatedBy", userId); // Replace with dynamic userId
      formData.append("file", selectedFile); // Attach selected file

      const response = await axios.post(
        `${baseURL}/Grievance/NameChangeCreateRequest?languageID=${language_id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (response.status === 200 && response.data.status === 1) {
        setRequestMessage(response.data.response);
        setShowUploadRequestDocModal(false);
        setShowRequestSuccessModal(true);
        checkProfileCompletion();

        setSelectedFile(null);
        setPreviewImage(null);
      } else if (response.data.errorCode === "GRV002") {
        setShowUploadRequestDocModal(false);
        setShowRequestSuccessModal(false);
        toast.error(response.data.message);
      } else {
        setShowUploadRequestDocModal(false);
        toast.error("Request creation failed..!");
      }
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  const getProfession = async () => {
    const response = await GetProfession();

    const data = response.map((item) => ({
      label: item?.name,
      value: item?.id,
    }));

    if (userDetails.professionId) {
      const filterProfession = data.filter(
        (item) => item.value === +userDetails.professionId,
      );

      setState((prevValues) => ({
        ...prevValues,
        professionId: filterProfession,
      }));
    }

    setProfessionOptions(data);
  };

  const getReasons = async () => {
    const response = await GetReasons();

    const data = response.map((item) => ({
      label: item?.name,
      value: item?.id,
    }));

    if (userDetails.reasonId) {
      const filterReason = data.filter(
        (item) => item.value === +userDetails.reasonId,
      );

      setState((prevValues) => ({
        ...prevValues,
        reasonId: filterReason,
      }));
    }
    setReasonOptions(data);
  };

  const getQualification = async () => {
    const response = await GetQualification(state?.professionId[0]?.value);
    const data = response.map((item) => ({
      value: item?.id,
      label: item?.name,
    }));

    if (userDetails.qualificationId) {
      const filterQualification = data.filter(
        (item) => item.value === +userDetails.qualificationId,
      );

      setState((prevValues) => ({
        ...prevValues,
        qualificationId: filterQualification,
      }));
    }

    setQualificationOptions(data);
  };

  const getSpecialization = async () => {
    const response = await GetSpecialization(
      state?.professionId[0]?.value,
      state?.qualificationId[0]?.value,
    );

    const data = response.map((item) => ({
      value: item?.id,
      label: item?.name,
    }));

    if (userDetails.specializationId) {
      const filterSpecialization = data.filter(
        (item) => item.value === +userDetails.specializationId,
      );

      setState((prevValues) => ({
        ...prevValues,
        specializationId: filterSpecialization,
      }));
    }

    setSpecializationOptions(data);
  };

  const [showModal, setShowModal] = useState(false);

  const [showChangeRequestModal, setShowChangeRequestModal] = useState(false);
  const [showUploadRequestDocModal, setShowUploadRequestDocModal] =
    useState(false);
  const [showRequestSuccessModal, setShowRequestSuccessModal] = useState(false);
  const [showReqAlreadySubmitModel, setShowReqAlreadySubmitModel] =
    useState(false);
  const [previewImage, setPreviewImage] = useState(null); // State for previewing image
  const [selectedFile, setSelectedFile] = useState(null);
  const [requestMessage, setRequestMessage] = useState("");
  const [requestTypeId, setRequestTypeId] = useState(0);

  const [shimmer, setShimmer] = useState(true);
  const [loader, setLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  // Handle file change
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
    if (file) {
      if (file.type.startsWith("image/")) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setPreviewImage(reader.result); // Set the image preview
        };
        reader.readAsDataURL(file); // Read the file as data URL for preview
      } else {
        setPreviewImage(null); // Reset preview if not an image
      }
    } else {
      setPreviewImage(null); // Reset preview when no file is selected
    }
  };

  const onClickChangeRequest = (requestTypeId) => {
    switch (requestTypeId) {
      case 1:
        if (checkProfileCompletionData?.grievanceNameChangeRequest === null) {
          setShowChangeRequestModal(true);
        } else {
          setShowReqAlreadySubmitModel(true);
        }
        setRequestTypeId(1);
        break;

      case 2:
        if (checkProfileCompletionData?.grievanceSchoolChangeRequest === null) {
          setShowChangeRequestModal(true);
        } else {
          setShowReqAlreadySubmitModel(true);
        }
        setRequestTypeId(2);
        break;

      default:
        break;
    }
  };

  const [checkProfileCompletionData, setCheckProfileCompletionData] = useState(
    [],
  );

  const checkProfileCompletion = async () => {
    const response = await CheckProfileCompletion(userId);
    setCheckProfileCompletionData(response?.data?.response);
    return response?.data?.response;
  };

  const handleKeyboardEvent = (e) => {
    if (firstName?.trim() === "" && e.key === " ") {
      e.preventDefault();
    }
  };

  const isFormValid = () => {
    if (!state?.firstName?.trim()) return false;
    if (!state?.dob) return false;
    if (!state?.genderId?.[0]?.value) return false;
    if (!state?.stateId?.[0]?.value) return false;
    if (!state?.districtId?.[0]?.value) return false;
    if (!state?.blockId?.[0]?.value) return false;

    // School required except for user types 8, 11, 12
    if (
      ![8, 11, 12].includes(userDetails?.userTypeId) &&
      !schoolByUdise &&
      !state?.schoolId?.[0]?.value
    ) {
      return false;
    }

    // User Type 7 => School OR Reason required
    if (
      userDetails?.userTypeId === 7 &&
      !schoolByUdise &&
      !state?.schoolId?.[0]?.value &&
      !state?.reasonId?.[0]?.value
    ) {
      return false;
    }

    // User Types 8 & 12
    if ([8, 12].includes(userDetails?.userTypeId)) {
      if (!state?.professionId?.[0]?.value) return false;
      if (!state?.qualificationId?.[0]?.value) return false;
    }

    // User Type 8
    if (userDetails?.userTypeId === 8 && !state?.specializationId?.[0]?.value) {
      return false;
    }

    // User Type 12
    if (userDetails?.userTypeId === 12) {
      if (!state?.crrNo?.trim()) return false;
    }

    // WhatsApp validation
    if (error) return false;

    return true;
  };

  useEffect(() => {
    getProfession();
    checkProfileCompletion();
    getReasons();
  }, []);

  useEffect(() => {
    if (state.professionId.length > 0) {
      getQualification();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.professionId]);

  useEffect(() => {
    if (state.qualificationId.length > 0) {
      getSpecialization();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.qualificationId]);

  useEffect(() => {
    setTimeout(() => {
      setShimmer(false);
    }, 4000);
  }, []);

  return (
    <>
      <div className="bg-gradient-to-b from-[#002EFF2B] to-[#0DE9FF2B] drop-shadow-[0_04px_20px_#00000021] grid grid-cols-1 md:grid-cols-6 md:gap-1 p-[20px] md:max-h-[100vh] h-[calc(100%_-_6%)] lg:h-[calc(100%_-_9%)] overflow-y-scroll">
        <div className="col-span-2 bg-[#ffffffad] rounded-md md:mr-[15px] mb-5 md:mb-0 backdrop-blur-md">
          <div className="flex mt-5 ml-5">
            <FontAwesomeIcon
              icon={""} //{faArrowLeft}
              style={{ color: "#000000" }}
              size="xl"
              onClick={() => navigate(-1)}
              className="mr-5 cursor-pointer"
            />
          </div>
          <div className="my-[20px] relative @mx-[60px]">
            <input
              accept="image/*"
              id="profile-picture"
              type={"file"}
              className="hidden"
              onChange={handleProfilPic}
            />
            <Avatars
              round={true}
              size={160}
              src={
                base64String ? base64String : userDetails?.profilePicURL
                // ? userDetails?.profilePicURL
                // : profileIcon
              }
            />
            {/* <div className="border-[#CACEE2] border-[1px] rounded-[100%] bg-[#fff] ps-[20px] flex justify-center">
              <img
                // src={profileIcon}
                src={base64String ? base64String : userDetails?.profilePicURL}
                className=""
              />
            </div> */}
            <label
              htmlFor="profile-picture"
              className="absolute right-[20%] xl:right-[60px] lg:right-[0px] md:top-[-2px] w-[30%]"
            >
              <img
                src={CameraImg}
                width="50%"
                className="text-[#ffffffad] cursor-pointer "
                alt=""
              />
            </label>
          </div>
          <div className="flex flex-row flex-wrap justify-evenly profile-form m-[50px]">
            <div className="basis-full flex flex-col text-left">
              <label htmlFor="username" className="mb-2 text-lg">
                {getTranslateText?.data?.length > 0
                  ? getTranslateText?.data?.filter(
                      (item) => item?.pageKey === "field_username",
                    )[0]?.keyValue
                  : "Username"}
              </label>
              <input
                id="username"
                type="text"
                className="bg-[#F2F8FB]"
                placeholder="Enter Name"
                value={decrypt(userDetails?.userName)}
                readOnly
              />
            </div>
            <div className="basis-full flex flex-col text-left">
              <label htmlFor="emailid" className="my-2 text-lg">
                {getTranslateText?.data?.length > 0
                  ? getTranslateText?.data?.filter(
                      (item) => item?.pageKey === "field_email",
                    )[0]?.keyValue
                  : "Email Id"}
              </label>
              <input
                id="emailid"
                name="emailId"
                type="email"
                className="bg-[#F2F8FB]"
                placeholder={
                  getTranslateText?.data?.length > 0
                    ? getTranslateText?.data?.filter(
                        (item) => item?.pageKey === "field_email",
                      )[0]?.keyValue
                    : "Email Id"
                }
                value={state?.emailId}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>

        <div className="col-span-4 bg-[#fff] rounded-md">
          <div className="flex flex-row justify-between items-center my-[21px] mx-[54px] ">
            <h1 className="text-[24px] text-left">
              {isProfileCompleted() === true ? (
                <>
                  {getTranslateText?.data?.length > 0
                    ? getTranslateText?.data?.filter(
                        (item) => item?.pageKey === "field_edit_profile",
                      )[0]?.keyValue
                    : "Create Profile"}
                </>
              ) : (
                <>
                  {getTranslateText?.data?.length > 0
                    ? getTranslateText?.data?.filter(
                        (item) => item?.pageKey === "field_edit_profile",
                      )[0]?.keyValue
                    : "Create Profile"}
                </>
              )}
            </h1>

            {!isProfileCompleted() ? (
              <p
                className="cursor-pointer text-red-600"
                onClick={() => {
                  setShowLogoutModal(true);
                  // localStorage.clear();
                  // navigate("/select/language");
                }}
              >
                <FontAwesomeIcon icon={faSignOutAlt} size="lg" />
              </p>
            ) : (
              <></>
            )}
          </div>
          {teacherId > 0 ? (
            <div className="bg-yellow-50 border border-yellow-100 rounded-lg p-4 mx-[7%]">
              <p className="text-gray-700 text-sm mb-2 text-left">
                {getTranslateText?.data?.length > 0
                  ? getTranslateText?.data?.filter(
                      (item) => item.pageKey === "gsrt_profile",
                    )[0].keyValue
                    ? getTranslateText?.data?.filter(
                        (item) => item.pageKey === "gsrt_profile",
                      )[0].keyValue
                    : "Your profile comes from govt. records and can't be edited here. To update, contact officials or refresh the data"
                  : "Your profile comes from govt. records and can't be edited here. To update, contact officials or refresh the data"}
              </p>
              <button
                onClick={() => {
                  setLoader(true);
                  setTimeout(() => {
                    toast.success(
                      getTranslateText?.data.length > 0
                        ? getTranslateText?.data?.filter(
                            (item) => item.pageKey === "key_profile_sync",
                          )[0].keyValue
                          ? getTranslateText?.data?.filter(
                              (item) => item.pageKey === "key_profile_sync",
                            )[0].keyValue
                          : "Profile sync successfully"
                        : "Profile sync successfully",
                    );
                    setLoader(false);
                  }, 2000);
                }}
                className="flex items-center text-[#3C57AD] text-[14px]"
              >
                {/* Refresh Icon (SVG) */}
                <img src={reload} alt="reload" className="mr-1"></img>
                {getTranslateText?.data?.length > 0
                  ? getTranslateText?.data?.filter(
                      (item) => item.pageKey === "key_refresh",
                    )[0].keyValue
                    ? getTranslateText?.data?.filter(
                        (item) => item.pageKey === "key_refresh",
                      )[0].keyValue
                    : "Refresh Data"
                  : "Refresh Data"}
              </button>
            </div>
          ) : (
            ""
          )}
          <form onSubmit={handleSubmit}>
            {shimmer ? (
              <>
                <ModuleListShimmer />
                <ModuleListShimmer />
                <ModuleListShimmer />
                <ModuleListShimmer />
                <ModuleListShimmer />
              </>
            ) : loader ? (
              <>
                <div
                  className="fixed top-0 left-0 right-0 bottom-0 flex justify-center items-center bg-opacity-0.5"
                  style={{ backgroundColor: "#D3D3D3" }}
                >
                  <Loader type="spinningBubbles" color="#2e376c" />
                </div>
              </>
            ) : (
              <>
                <div className="flex flex-row flex-wrap	justify-evenly profile-form">
                  <div className="basis-4/5 md:basis-2/5	flex flex-col text-left">
                    <div className="flex flex-row justify-between w-[100%]">
                      <label>
                        {getTranslateText?.data?.length > 0
                          ? getTranslateText?.data?.filter(
                              (item) => item?.pageKey === "field_fname_mname",
                            )[0]?.keyValue
                          : "First & Middle Name"}
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      {isProfileCompleted() === true ? (
                        <>
                          <p
                            className={` ${
                              userDetails?.userTypeId === 9
                                ? "hidden"
                                : "cursor-pointer"
                            } text-[13px] text-[#2C519A] underlines font-medium`}
                            // onClick={() => {
                            //   changeRequest(1);
                            // }}
                            onClick={() => {
                              //setShowModal(true);
                              //setRequestTypeId(1);
                              onClickChangeRequest(1);
                              //changeRequest(language_id, 1);
                            }}
                          >
                            {teacherId > 0
                              ? ""
                              : getTranslateText?.data?.length > 0
                                ? getTranslateText?.data?.filter(
                                    (item) => item.pageKey === "label_change",
                                  )[0].keyValue
                                : "Change"}
                          </p>
                        </>
                      ) : (
                        ""
                      )}
                    </div>

                    <input
                      name="firstName"
                      className={`${
                        isProfileCompleted() === true
                          ? "bg-[#eee] pointer-events-none text-[#000000a8]"
                          : ""
                      } bg-[#F2F8FB]`}
                      type={"text"}
                      maxLength={30}
                      minLength={2}
                      placeholder={
                        getTranslateText?.data?.length > 0
                          ? getTranslateText?.data?.filter(
                              (item) => item?.pageKey === "field_fname_mname",
                            )[0]?.keyValue
                          : "First & Middle Name"
                      }
                      onChange={(e) => {
                        // setFullName(e.target.value);

                        // const result = e.target.value.replace(/[^a-z]/gi, "");
                        setState({ ...state, firstName: e.target.value });
                      }}
                      // onChange={(e) => {
                      //   setFullName(e.target.value);
                      //   setState({ ...state, firstName: result });
                      // }}
                      onKeyDown={handleKeyboardEvent}
                      value={state?.firstName}
                      required
                    />
                    {/* <p>Hints</p> */}
                  </div>
                  <div className="basis-4/5 md:basis-2/5	">
                    <div className="flex flex-row justify-between w-[80%]">
                      <label>
                        {getTranslateText?.data?.length > 0
                          ? getTranslateText?.data?.filter(
                              (item) => item?.pageKey === "field_lname",
                            )[0]?.keyValue
                          : "Last Name"}
                        {/* <span style={{ color: "red" }}>*</span> */}
                      </label>
                      {isProfileCompleted() === true ? (
                        <>
                          <p
                            className="text-[13px] text-[#2C519A] underlines font-medium cursor-pointer hidden"
                            onClick={() => {
                              setShowModal(true);
                              changeRequest(language_id, 1);
                            }}
                          >
                            {getTranslateText?.data?.length > 0
                              ? getTranslateText?.data?.filter(
                                  (item) => item.pageKey === "label_change",
                                )[0].keyValue
                              : "Change"}
                          </p>
                        </>
                      ) : (
                        ""
                      )}
                    </div>

                    <input
                      name="lastName"
                      type={"text"}
                      maxLength={30}
                      minLength={" "}
                      className={`${
                        isProfileCompleted() === true
                          ? "bg-[#eee] pointer-events-none text-[#000000a8]"
                          : ""
                      } bg-[#F2F8FB]`}
                      // className="bg-[#f2f8fb] text-[#000000a8]"
                      placeholder={
                        getTranslateText?.data?.length > 0
                          ? getTranslateText?.data?.filter(
                              (item) => item?.pageKey === "field_lname",
                            )[0]?.keyValue
                          : "Last Name"
                      }
                      onChange={(e) => {
                        const result = e.target.value.replace(/[^a-z]/gi, "");
                        setState({ ...state, lastName: result });
                      }}
                      value={state?.lastName}
                      // value=""
                    />
                  </div>
                  <div className="basis-4/5 md:basis-2/5	flex flex-col">
                    <label>
                      {getTranslateText?.data?.length > 0
                        ? getTranslateText?.data?.filter(
                            (item) => item?.pageKey === "field_dob",
                          )[0]?.keyValue
                        : " DOB"}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type={"date"}
                      className="bg-[#F2F8FB]"
                      name="dob"
                      required
                      max={currentDate}
                      title="Date of birth should be greater then 18 years"
                      value={state?.dob}
                      onChange={(e) => {
                        const enteredDate = new Date(e.target.value);
                        const currentDate = new Date();
                        const minDate = new Date(
                          currentDate.getFullYear() - 18,
                          currentDate.getMonth(),
                          currentDate.getDate(),
                        );

                        if (enteredDate > minDate) {
                          // DOB is less than 18 years
                          //  setShowDobErrorMessage(true);
                        } else {
                          // DOB is greater than or equal to 18 years
                          //  setShowDobErrorMessage(false);
                          handleChange(e);
                        }
                        // handleChange(e);
                      }}
                      disabled={userDetails.dob && teacherId > 0}
                    />
                  </div>
                  <div className="basis-4/5 md:basis-2/5	">
                    <label>
                      {getTranslateText?.data?.length > 0
                        ? getTranslateText?.data?.filter(
                            (item) => item?.pageKey === "field_gender",
                          )[0]?.keyValue
                        : "Gender"}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <Select
                      options={gendersSelector?.data}
                      value={state?.genderId}
                      required
                      onChange={(selectedOption) => {
                        setState({ ...state, genderId: [selectedOption] });
                      }}
                      isDisabled={userDetails.gender && teacherId > 0}
                    />
                  </div>
                  <div className="basis-4/5 md:basis-2/5	">
                    <label>
                      {getTranslateText?.data?.length > 0
                        ? getTranslateText?.data?.filter(
                            (item) => item?.pageKey === "field_phone_number",
                          )[0]?.keyValue
                        : "Phone Number"}
                      {/* Phone Number */}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type={"text"}
                      name="mobileNo"
                      className="bg-[#F2F8FB]"
                      placeholder="Enter phone number"
                      // value={decrypt(state?.mobileNo)}
                      value={
                        localStorage.getItem("mobileno")
                          ? localStorage.getItem("mobileno")
                          : state?.mobileNo
                      }
                      onKeyDown={(e) => {
                        if (e.key === " ") {
                          e.preventDefault();
                        }
                      }}
                      readOnly
                      minLength={10}
                      maxLength={10}
                      required
                    />
                  </div>
                  <div className="basis-4/5 md:basis-2/5	">
                    <label>
                      {getTranslateText?.data?.length > 0
                        ? getTranslateText?.data?.filter(
                            (item) => item?.pageKey === "field_whatsapp_number",
                          )[0]?.keyValue
                        : " Whatsapp Number"}
                    </label>
                    <input
                      type={"text"}
                      name="whatsAppNo"
                      className="bg-[#F2F8FB]"
                      placeholder={
                        getTranslateText?.data?.length > 0
                          ? getTranslateText?.data?.filter(
                              (item) =>
                                item?.pageKey === "field_whatsapp_number",
                            )[0]?.keyValue
                          : " Whatsapp Number"
                      }
                      value={state.whatsAppNo}
                      onKeyDown={(e) => {
                        if (e.key === " ") {
                          e.preventDefault();
                        }
                      }}
                      onChange={(e) => {
                        if (!e.target.value) {
                          setError(false);
                          setState({ ...state, whatsAppNo: "" });
                        } else if (!indianMobileNumber.test(e.target.value)) {
                          setError(true);
                          setState({ ...state, whatsAppNo: e.target.value });
                        } else {
                          setError(false);
                          setState({ ...state, whatsAppNo: e.target.value });
                        }
                      }}
                      minLength={10}
                      maxLength={10}
                      disabled={teacherId > 0}
                    />
                    {error && (
                      <p style={{ color: "red" }}>Invalid mobile number</p>
                    )}
                  </div>

                  {userDetails.userTypeId === 11 ||
                  userDetails.userTypeId === 12 ||
                  userDetails.userTypeId === 8 ? (
                    ""
                  ) : (
                    <>
                      <div className="basis-4/5 md:basis-2/5	">
                        <label>
                          {getTranslateText?.data?.length > 0
                            ? getTranslateText?.data?.filter(
                                (item) => item?.pageKey === "label_udise",
                              )[0]?.keyValue
                            : "School Udise Name"}
                        </label>
                        <div className="!flex !flex-row justify-between md:justify-start w-[100%]">
                          <input
                            type={"text"}
                            className="bg-[#F2F8FB] w-[80%] md:!w-[95%] mr-2"
                            placeholder={
                              getTranslateText?.data?.length > 0
                                ? getTranslateText?.data?.filter(
                                    (item) => item?.pageKey === "hint_udise",
                                  )[0]?.keyValue
                                : "Enter UDISE Code"
                            }
                            value={UdiseCode}
                            maxLength={11}
                            disabled={isProfileCompleted()}
                            title={
                              isProfileCompleted()
                                ? "Click on change button for school updation..!"
                                : ""
                            }
                            onChange={(e) => {
                              const input = e.target.value;
                              //if (!/^\d+$/.test(input)) {
                              if (!/^[a-zA-Z0-9]*$/.test(input)) {
                                e.preventDefault();
                                if (UdiseCode.length === 1) {
                                  // handleChange(e);
                                  setUdiseCode(e.target.value);
                                }
                              } else {
                                setUdiseCode(e.target.value);
                              }
                            }}
                          />
                          <button
                            type="button"
                            className="bg-gradient-to-b from-[#B0BDFF] to-[#5E77F9] text-white rounded-md px-3 text-sm"
                            style={{ textWrap: "nowrap" }}
                            disabled={!UdiseCode || isProfileCompleted()}
                            onClick={(e) => {
                              applyUdise();
                              setShowButtonText(!showButtonText);
                            }}
                          >
                            {showButtonText
                              ? getTranslateText?.data?.length > 0
                                ? getTranslateText?.data?.filter(
                                    (item) => item?.pageKey === "reset_btn",
                                  )[0]?.keyValue
                                : "Reset"
                              : getTranslateText?.data?.length > 0
                                ? getTranslateText?.data?.filter(
                                    (item) => item?.pageKey === "label_okay",
                                  )[0]?.keyValue
                                : "Apply"}
                          </button>
                        </div>
                      </div>
                    </>
                  )}

                  <div className="basis-4/5 md:basis-2/5	">
                    <label>
                      {getTranslateText?.data?.length > 0
                        ? getTranslateText?.data?.filter(
                            (item) => item?.pageKey === "field_state",
                          )[0]?.keyValue
                        : "State"}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <Select
                      options={statesSelector?.data}
                      value={!stateByUdise ? state.stateId : stateByUdise}
                      required
                      onChange={(selectedOption) => {
                        dispatch(clearDistrictList());
                        dispatch(clearBlockList());
                        dispatch(clearSchoolList());
                        if (!isProfileCompleted()) {
                          setState({
                            ...state,
                            stateId: [selectedOption],
                            blockId: "",
                            schoolId: "",
                          });
                        } else {
                          setState({
                            ...state,
                            stateId: [selectedOption],
                            blockId: "",
                          });
                        }
                      }}
                      isDisabled={
                        hasStateIdInUrl ||
                        showButtonText ||
                        isProfileCompleted() === true
                      }
                    />
                  </div>
                  <div className="basis-4/5 md:basis-2/5	">
                    <label>
                      {getTranslateText?.data?.length > 0
                        ? getTranslateText?.data?.filter(
                            (item) => item?.pageKey === "field_district",
                          )[0]?.keyValue
                        : "District"}
                      <span style={{ color: "red" }}>*</span>
                    </label>

                    <Select
                      options={districtsSelector?.data}
                      value={
                        !districtByUdise ? state?.districtId : districtByUdise
                      }
                      required
                      onChange={(selectedOption) => {
                        dispatch(clearBlockList());
                        dispatch(clearSchoolList());
                        if (!isProfileCompleted()) {
                          setState({
                            ...state,
                            districtId: [selectedOption],
                            schoolId: "",
                          });
                        } else {
                          setState({
                            ...state,
                            districtId: [selectedOption],
                          });
                        }
                      }}
                      isDisabled={
                        showButtonText || isProfileCompleted() === true
                      }
                    />
                  </div>
                  <div className="basis-4/5 md:basis-2/5	">
                    <label>
                      {getTranslateText?.data?.length > 0
                        ? getTranslateText?.data?.filter(
                            (item) => item?.pageKey === "field_block",
                          )[0]?.keyValue
                        : "Block/Zone/KVS Region"}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <Select
                      options={blocksSelector?.data}
                      value={!blockByUdise ? state?.blockId : blockByUdise}
                      required
                      onChange={(selectedOption) => {
                        dispatch(clearSchoolList());
                        if (!isProfileCompleted()) {
                          setState({
                            ...state,
                            blockId: [selectedOption],
                            schoolId: "",
                          });
                        } else {
                          setState({
                            ...state,
                            blockId: [selectedOption],
                          });
                        }
                      }}
                      isDisabled={
                        showButtonText || isProfileCompleted() === true
                      }
                    />
                  </div>

                  {userDetails.userTypeId === 11 ||
                  userDetails.userTypeId === 12 ||
                  userDetails.userTypeId === 8 ? (
                    ""
                  ) : (
                    <>
                      <div className="basis-4/5 md:basis-2/5	">
                        <div className="flex flex-row justify-between w-[100%]">
                          <label>
                            {getTranslateText?.data?.length > 0
                              ? getTranslateText?.data?.filter(
                                  (item) => item?.pageKey === "field_school",
                                )[0]?.keyValue
                              : "School"}
                            <span style={{ color: "red" }}>
                              {userDetails?.userTypeId === 7 ? "" : "*"}
                            </span>
                          </label>
                          {isProfileCompleted() === true &&
                          userDetails?.schoolId > 0 ? (
                            <>
                              <p
                                className={`${
                                  userDetails?.userTypeId === 9
                                    ? "hidden"
                                    : "cursor-pointer"
                                } text-[13px] text-[#2C519A] underlines font-medium`}
                                onClick={() => {
                                  // setShowModal(true);
                                  // changeRequest(language_id, 2);
                                  //setRequestTypeId(2);
                                  onClickChangeRequest(2);
                                }}
                              >
                                {teacherId > 0
                                  ? ""
                                  : getTranslateText?.data?.length > 0
                                    ? getTranslateText?.data?.filter(
                                        (item) =>
                                          item?.pageKey === "label_change",
                                      )[0]?.keyValue
                                    : "Change"}
                              </p>
                            </>
                          ) : (
                            ""
                          )}
                        </div>

                        <Select
                          className={`${
                            isProfileCompleted() === true
                              ? "[&_.css-13cymwt-control]:bg-[#eee] pointer-events-none text-[#000000a8]"
                              : ""
                          } bg-[#F2F8FB]`}
                          options={schoolsSelector?.data}
                          value={
                            !schoolByUdise ? state?.schoolId : schoolByUdise
                          }
                          //required
                          onChange={(selectedOption) => {
                            if (selectedOption.value === 0) {
                              // setState({
                              //   ...state,
                              //   schoolId: [{ value: 0, label: "other" }],
                              // });
                              setState({
                                ...state,
                                schoolId: [selectedOption],
                              });
                              setShowSchoolName(true);
                            } else {
                              setShowSchoolName(false);
                              setState({
                                ...state,
                                schoolId: [selectedOption],
                              });
                            }
                          }}
                          isDisabled={showButtonText}
                        />
                        {showSchoolName && (
                          <input
                            type={"text"}
                            name="schoolName"
                            className="bg-[#F2F8FB] mr-2 mt-2"
                            required
                            placeholder="Enter school name"
                            maxLength={150}
                            onChange={(e) => {
                              setState({
                                ...state,
                                schoolName: e.target.value,
                              });
                            }}
                          />
                        )}
                      </div>
                    </>
                  )}

                  {userDetails.userTypeId === 7 ? (
                    <div className="basis-4/5 md:basis-2/5	">
                      <label>
                        {getTranslateText?.data?.length > 0
                          ? getTranslateText?.data?.filter(
                              (item) => item?.pageKey === "label_reason",
                            )[0]?.keyValue
                          : "Reason"}
                      </label>
                      <span
                        style={{
                          fontSize: "12px",
                          color: "grey",
                        }}
                      >
                        (
                        {getTranslateText?.data?.length > 0
                          ? getTranslateText?.data?.filter(
                              (item) => item?.pageKey === "lable_no_school",
                            )[0]?.keyValue
                          : "If school not selected"}
                        )
                      </span>
                      <Select
                        options={reasonOptions}
                        value={state?.reasonId?.[0]}
                        placeholder="Please select reason"
                        onChange={(selectedOption) => {
                          setState({
                            ...state,
                            reasonId: [selectedOption],
                          });
                        }}
                        isDisabled={
                          showButtonText ||
                          (state?.schoolId?.[0]?.value &&
                            state?.schoolId?.[0]?.value !== 0)
                        }
                      />
                    </div>
                  ) : (
                    ""
                  )}

                  {userDetails.userTypeId === 7 ||
                  userDetails.userTypeId === 8 ||
                  userDetails.userTypeId === 11 ||
                  userDetails.userTypeId === 12 ? (
                    <>
                      <div className="basis-4/5 md:basis-2/5	">
                        <label>
                          {/* Profession */}
                          {getTranslateText?.data?.length > 0
                            ? getTranslateText?.data?.filter(
                                (item) => item?.pageKey === "key_profession",
                              )[0]?.keyValue
                            : "Profession"}
                          <span style={{ color: "red" }}>
                            {userDetails?.userTypeId === 8 ||
                            userDetails.userTypeId === 12
                              ? "*"
                              : ""}
                          </span>
                        </label>
                        <Select
                          options={professionOptions}
                          value={state?.professionId[0]}
                          placeholder="Please select profession"
                          onChange={(selectedOption) => {
                            setState({
                              ...state,
                              professionId: [selectedOption],
                              specializationId: [],
                              qualificationId: [],
                            });
                          }}
                        />
                      </div>
                    </>
                  ) : (
                    ""
                  )}

                  {userDetails.userTypeId === 7 ||
                  userDetails.userTypeId === 8 ||
                  userDetails.userTypeId === 12 ? (
                    <>
                      <div className="basis-4/5 md:basis-2/5	">
                        <label>
                          {getTranslateText?.data?.length > 0
                            ? getTranslateText?.data?.filter(
                                (item) => item?.pageKey === "key_qualification",
                              )[0]?.keyValue
                            : "Qualification"}
                          <span style={{ color: "red" }}>
                            {userDetails?.userTypeId === 8 ||
                            userDetails.userTypeId === 12
                              ? "*"
                              : ""}
                          </span>
                        </label>
                        <Select
                          options={qualificationOptions}
                          // required
                          placeholder="Please select qualification"
                          value={state?.qualificationId[0]}
                          onChange={(selectedOption) => {
                            setState({
                              ...state,
                              qualificationId: [selectedOption],
                            });
                          }}
                        />
                      </div>
                      {userDetails.userTypeId === 12 ? (
                        ""
                      ) : (
                        <>
                          <div className="basis-4/5 md:basis-2/5	">
                            <label>
                              {getTranslateText?.data?.length > 0
                                ? getTranslateText?.data?.filter(
                                    (item) =>
                                      item?.pageKey === "key_specialization",
                                  )[0]?.keyValue
                                : "Specialization"}
                              <span style={{ color: "red" }}>
                                {userDetails?.userTypeId === 8 ? "*" : ""}
                              </span>
                            </label>
                            <Select
                              placeholder="Please select profession"
                              value={state?.specializationId[[0]]}
                              // required
                              options={specializationOptions}
                              onChange={(selectedOption) => {
                                setState({
                                  ...state,
                                  specializationId: [selectedOption],
                                });
                              }}
                            />
                          </div>
                        </>
                      )}
                      <div className="basis-4/5 md:basis-2/5	">
                        <label>CRR No</label>
                        <span style={{ color: "red" }}>
                          {userDetails.userTypeId === 12 ? "*" : ""}
                        </span>
                        <input
                          type={"text"}
                          value={state.crrNo}
                          maxLength={8}
                          //className="bg-[#F2F8FB] w-[80%] md:!w-[95%] mr-2"
                          className={`${
                            userDetails.crrNum
                              ? "bg-[#eee] pointer-events-none text-[#000000a8]"
                              : ""
                          } bg-[#F2F8FB] w-[80%] md:!w-[100%] mr-2`}
                          placeholder="CRR NO"
                          onChange={(e) => {
                            setState({ ...state, crrNo: e.target.value });
                          }}
                          disabled={!!userDetails.crrNum}
                        />
                        {state.crrNo && !crrNumberRegex.test(state.crrNo) ? (
                          <label style={{ color: "red" }}>
                            Invalid crr number
                          </label>
                        ) : (
                          ""
                        )}
                      </div>
                    </>
                  ) : (
                    ""
                  )}

                  {userDetails.userTypeId === 12 ? (
                    <>
                      <div className="basis-4/5 md:basis-2/5	">
                        <label>Name of the Institution</label>
                        <input
                          type={"text"}
                          value={state.institutionName}
                          maxLength={100}
                          className="bg-[#F2F8FB] w-[80%] md:!w-[95%] mr-2"
                          placeholder="Name of the Institution"
                          onChange={(e) => {
                            setState({
                              ...state,
                              institutionName: e.target.value,
                            });
                          }}
                        />
                      </div>
                    </>
                  ) : (
                    ""
                  )}

                  <div className="basis-4/5 md:basis-2/5	"></div>
                  <div className="basis-4/5 md:basis-2/5	">
                    <button
                      type="submit"
                      className={`${
                        userDetails?.userTypeId === 9 ? "hidden" : ""
                      }${
                        loading || !isFormValid()
                          ? "bg-[#3a3e58] text-[#fff] py-3 px-[40px] xl:px-20 lg:px-14 rounded-md mt-5 flex relative m-auto md:m-1 px-[40px]"
                          : "bg-[#101942] text-[#fff] py-3 px-[40px] xl:px-20 lg:px-14 rounded-md mt-5 flex relative m-auto md:m-1 px-[40px]"
                      }`}
                      disabled={!isFormValid() || loading}
                    >
                      {loading ? (
                        <>
                          <div className="flex items-center space-x-2">
                            <div className="spinner-border animate-spin inline-block w-4 h-4 border-4 rounded-full"></div>
                            <span>Loading...</span>
                          </div>
                        </>
                      ) : getTranslateText?.data?.length > 0 ? (
                        getTranslateText?.data?.filter(
                          (item) => item?.pageKey === "btn_proceed",
                        )[0]?.keyValue
                      ) : (
                        "Proceed"
                      )}
                      <ReactIcons.AiFillRightCircle className="absolute right-3 top-[13px] text-[#fff] text-xl" />
                    </button>
                  </div>
                </div>
              </>
            )}
          </form>
        </div>

        {showMessage && <ToastContainer />}
      </div>

      {/* commented on 2024-10-09 'This popup is used to show request created and request already created message' */}
      {/* <Modal
        onClick={() => setShowModal(false)}
        onClose={() => setShowModal(false)}
        visible={showModal}
      >
        <div className="w-96 bg-[#fff] p-[20px] rounded-[20px] flex flex-col justify-center">
          <img
            src="../../Images/puzzle_smile.svg"
            alt="Puzzle Smiley Icon"
            className="w-[30%] m-auto"
          />
          <h2 className="text-[20px] my-2">
            {getTranslateText?.data?.length > 0
              ? getTranslateText?.data?.filter(
                  (item) => item?.pageKey === "key_request_name"
                )[0]?.keyValue
              : "Request Created"}
          </h2>
          <p className="text-[14px]">
            {getTranslateText?.data?.length > 0
              ? getTranslateText?.data?.filter(
                  (item) => item?.pageKey === "request_already_registered"
                )[0]?.keyValue
              : { changeRequestData }}
          </p>
          ();
          <p
            className="bg-gradient-to-r from-[#2C3EA2] to-[#192867] text-[#fff] px-[50px] py-[10px] rounded-[10px] mt-[20px]  flex flex-row justify-center cursor-pointer"
            onClick={() => setShowModal(false)}
          >
            {getTranslateText?.data?.length > 0
              ? getTranslateText?.data?.filter(
                  (item) => item?.pageKey === "label_okay"
                )[0]?.keyValue
              : "Okay"}
          </p>
        </div>
      </Modal> */}

      {/* View Name change request required Document list Modal */}
      <Modal visible={showChangeRequestModal}>
        <div className="relative w-96 bg-[#fff] p-[20px] rounded-[20px] flex flex-col justify-center">
          {/* Close icon inside the modal content, adjusted position */}
          <p
            className="absolute top-4 right-4 bg-[#f6f7fa] rounded-full w-[30px] h-[30px] flex justify-center items-center cursor-pointer z-10"
            onClick={() => setShowChangeRequestModal(false)}
          >
            <FontAwesomeIcon
              icon={faXmark}
              size="lg"
              style={{ color: "#3c3f4f" }}
            />
          </p>

          {/* Centered Image */}
          <img
            src="../../Images/user-profile-thumbnail.png"
            alt="Puzzle Smiley Icon"
            className="w-[30%] m-auto my-0"
          />

          <h2 className="text-[17px] my-2 text-[#101942]">
            <b>
              {" "}
              {requestTypeId === 1
                ? "Please upload a valid ID proof for the Name change request"
                : "Please upload a valid ID proof for the School name change request"}{" "}
            </b>
          </h2>

          <h6 className="text-[14px] text-[#565D7A]">
            Please upload one of these IDs-
          </h6>
          <br />
          {requestTypeId === 1 ? (
            <ul className="text-[15px] text-[#565D7A] text-left">
              <li className="p-[8px]">1. Aadhaar Card (front only) </li>
              <li className="p-[8px]">2. Pan Card (front only) </li>
              <li className="p-[8px]">3. Voter ID (front only) </li>
              <li className="p-[8px]">4. Driving Licence (front only) </li>
            </ul>
          ) : (
            <ul className="text-[15px] text-[#565D7A] text-left">
              <li className="p-[8px]">1. School ID Card (front only) </li>
              <li className="p-[8px]">
                2. Authorization Letter from the school{" "}
              </li>
            </ul>
          )}

          <p
            className="bg-gradient-to-r from-[#2C3EA2] to-[#192867] text-[#fff] px-[50px] py-[10px] rounded-[10px] mt-[20px] flex flex-row justify-center cursor-pointer"
            onClick={() => {
              setShowChangeRequestModal(false);
              setShowUploadRequestDocModal(true);
            }}
          >
            Continue
          </p>
        </div>
      </Modal>

      {/* Upload Document and preview Modal */}
      <Modal visible={showUploadRequestDocModal}>
        <div className="relative w-96 bg-[#fff] p-[20px] rounded-[20px] flex flex-col justify-center">
          <p
            className="absolute top-4 right-4 bg-[#f6f7fa] rounded-full w-[30px] h-[30px] flex justify-center items-center cursor-pointer z-10"
            onClick={() => setShowUploadRequestDocModal(false)}
          >
            <FontAwesomeIcon
              icon={faXmark}
              size="md"
              style={{ color: "#3c3f4f" }}
            />
          </p>

          <h2 className="text-[17px] my-4 text-[#101942] text-center">
            <b> Upload Document </b>
          </h2>

          <h6 className="text-[14px] text-[#565D7A]">
            Please upload a clear copy of your id proof, only front side for
            name varifaction.
          </h6>
          <br />
          {/* Large Upload Area */}
          <label className="w-full h-[200px] border-2 border-dashed border-[#F9B239] rounded-[10px] flex flex-col items-center justify-center cursor-pointer">
            <input
              type="file"
              className="hidden"
              onChange={handleFileChange} // Add this if you want to handle file input change
            />
            {/* If previewImage exists, display it */}
            {previewImage ? (
              <img
                src={previewImage}
                alt="Preview"
                className="w-full h-full object-contain rounded-[10px]"
              />
            ) : (
              <>
                <p className="text-[#F9B239] font-semibold text-center">
                  Please choose and upload the front side image
                </p>
                <p className="text-[#565D7A] text-center text-[14px]">
                  (Select image and maximum size: 10MB)
                </p>
              </>
            )}
          </label>

          <p
            className={
              selectedFile === null || selectedFile === ""
                ? "bg-gradient-to-r from-[#2235A1] to-[#121F55] text-[#fff] px-[50px] py-[10px] rounded-[10px] mt-[20px]  flex flex-row justify-center cursor-pointer bg-gradient-to-r from-[#3a3e58] to-[#777f94]"
                : "bg-gradient-to-r from-[#2C3EA2] to-[#192867] text-[#fff] px-[50px] py-[10px] rounded-[10px] mt-[20px]  flex flex-row justify-center cursor-pointer"
            }
            onClick={() => changeRequest(requestTypeId)}
          >
            Upload
          </p>
        </div>
      </Modal>

      {/* Name change request submit success model */}
      <Modal visible={showRequestSuccessModal}>
        <div className="w-96 bg-[#fff] p-[20px] rounded-[20px] flex flex-col justify-center">
          <img
            src="../../Images/success-icon.png"
            alt="Puzzle Smiley Icon"
            className="w-[30%] m-auto"
          />
          <h2 className="text-[17px] my-2 text-[#101942]">
            <b> Document Received! </b>
          </h2>

          <h6 className="text-[14px] text-[#565D7A]">{requestMessage}</h6>

          <div className="flex flex-row justify-between items-center my-0">
            <a
              href=""
              target="_blank"
              className="w-[12%]"
              onClick={() =>
                window.open(
                  "https://mail.google.com/mail/?view=cm&fs=1&to=support.pi@aurosociety.org",
                  "_blank",
                )
              }
            >
              <img src="../../Images/email-icon.png" alt="Email Icon" />
            </a>
            <a
              href="https://wa.me/919355902926"
              target="_blank"
              className="w-[12%]"
            >
              <img src={whatsappIcon} alt="WhatsApp Icon" />
            </a>
          </div>

          <p
            className="bg-gradient-to-r from-[#2C3EA2] to-[#192867] text-[#fff] px-[50px] py-[10px] rounded-[10px] mt-[20px]  flex flex-row justify-center cursor-pointer"
            onClick={() => setShowRequestSuccessModal(false)}
          >
            okay
          </p>
        </div>
      </Modal>

      {/* Name change request already submitted Modal */}
      <Modal visible={showReqAlreadySubmitModel}>
        <div className="w-96 bg-[#fff] p-[20px] rounded-[20px] flex flex-col justify-center">
          <h2 className="text-[17px] my-2 text-[#101942]">
            <b>
              {requestTypeId === 1
                ? getTranslateText?.data?.length > 0
                  ? getTranslateText?.data?.filter(
                      (item) => item?.pageKey === "key_name_change_req",
                    )[0]?.keyValue
                  : "Name change request already submitted!"
                : getTranslateText?.data?.length > 0
                  ? getTranslateText?.data?.filter(
                      (item) => item?.pageKey === "key_school_change_req",
                    )[0]?.keyValue
                  : "School name change request already submitted!"}
            </b>
          </h2>

          <h6 className="text-[14px] text-[#565D7A]">
            {requestTypeId === 1
              ? checkProfileCompletionData?.grievanceNameChangeRequest?.response
              : checkProfileCompletionData?.grievanceSchoolChangeRequest
                  ?.response}
          </h6>

          <div className="flex flex-row justify-between items-center my-0">
            <a
              onClick={() =>
                window.open(
                  "https://mail.google.com/mail/?view=cm&fs=1&to=support.pi@aurosociety.org",
                  "_blank",
                )
              }
              target="_blank"
              className="w-[12%]"
              style={{ cursor: "pointer" }}
            >
              <img src="../../Images/email-icon.png" alt="Email Icon" />
            </a>
            <a
              href="https://wa.me/919355902926"
              target="_blank"
              className="w-[12%]"
              rel="noreferrer"
            >
              <img src={whatsappIcon} alt="WhatsApp Icon" />
            </a>
          </div>

          <p
            className="bg-gradient-to-r from-[#2C3EA2] to-[#192867] text-[#fff] px-[50px] py-[10px] rounded-[10px] mt-[20px]  flex flex-row justify-center cursor-pointer"
            onClick={() => setShowReqAlreadySubmitModel(false)}
          >
            {getTranslateText?.data?.length > 0
              ? getTranslateText?.data?.filter(
                  (item) => item?.pageKey === "label_okay",
                )[0]?.keyValue
              : "Okay"}
          </p>
        </div>
      </Modal>

      {/*Logout modal popup*/}
      <LogoutModalPopup
        visible={showLogoutModal}
        onClose={() => setShowLogoutModal(false)}
        getTranslateText={getTranslateText}
      />

      <ServerUpgradtionModal
        show={serverError}
        setShow={setServerError}
        apiCall={handleSubmit}
      />
    </>
  );
};

export default Profile;
